<template>
	<div class="text-divider-container" role="separator">
		<div class="line" :style="lineStyle" />
		<div class="text" :style="textStyle">{{ text }}</div>
		<div class="line" :style="lineStyle" />
	</div>
</template>

<script>
export default {
	name: 'TextDivider',
	props: {
		text: String,
		textStyle: {
			type: Object,
			default: () => ({}),
		},
		lineStyle: {
			type: Object,
			default: () => ({}),
		},
	},
}
</script>

<style scoped>
.text-divider-container {
	display: flex;
	align-items: center;
}
.text {
	margin: 0 16px;
	white-space: nowrap;
}
.line {
	width: 100%;
	border-top: 1px solid var(--neutral-200);
}
</style>
